// extracted by mini-css-extract-plugin
export default {"CrashGames":"CrashGames_CrashGames__0GN-q","Logo":"CrashGames_Logo__AaYvp"};